export type Rating = 'One' | 'Four' | 'Five';

export enum Score {
	Exceptional = 'exceptional',
	Good = 'good',
	Reasonable = 'reasonable',
	Substandard = 'substandard',
}

const useScoreHelper = () => {
	const mappedScores: { rating: Rating, score: Score }[] = [
		{
			rating: 'One',
			score: Score.Substandard,
		}, {
			rating: 'Four',
			score: Score.Good,
		}, {
			rating: 'Five',
			score: Score.Exceptional,
		}
	];

	const getScoreByAverageRating = (averageRating: number) => {
		if (averageRating >= 0 && averageRating < 2) {
			return Score.Substandard;
		} else if (averageRating >= 2 && averageRating <= 3) {
			return Score.Reasonable;
		} else if (averageRating > 3 && averageRating <= 4) {
			return Score.Good;
		} else if (averageRating > 4 && averageRating <= 5) {
			return Score.Exceptional;
		} else return undefined;
	};
	const getScoreByRating = (rating: Rating) => {
		const item = mappedScores.find(item => item.rating === rating)
		if (item) {
			return item.score;
		}

		return Score.Substandard;
	};

	return {
		getScoreByAverageRating,
		getScoreByRating,
		mappedScores,
	};
} 

export default useScoreHelper;